import { RootState } from '../core'

export const selectProfile = (state: RootState) => state.profile

export const selectDisplayName = (state: RootState) => {
  const { firstName, lastName } = state.profile
  return `${firstName} ${lastName}`.trim()
}
